export const navItems = [
    { path: "/main", text: "Photo generator" },
    { path: "/video", text: "Video generator" },
    { path: "/gallery", text: "Gallery" },
    { path: "/pricing", text: "Pricing" }
];

export const logoText = { primary: "ARTLY", accent: "PIGS" };
